export const utilityColors = {
  utilityBackground: '#F4F6F5',
  utilityInformationBackground: '#EAEDEC',
  utilityDivider: '#BFCAC6',
  utilityText: '#3C3D41',
  utilityWhite: '#FFF',
} as const;
